<template>

	<div class="row" id="Lista">
		<div class="col-12 align-self-center" style="margin-bottom: 20px;">
			<h4 class="page-title">数据中心</h4>
			<h6 class="card-subtitle"> System administrator list</h6>
		</div>

		<div class="col-md-6 col-sm-6" v-for="list in lists">
			<el-card shadow="hover" class="el_card_b">

				<div class="card  card-hover">
					<div class="card-header" style="z-index: 0" @click="getServerURl(list.app_connect_list,list.type_id)">
						<b class="m-b-0 text-gray" style="height: 30px; line-height: 30px;">
							{{list.title}}
						</b>
					</div>
					<div class="card-body">
						<div class="d-flex flex-row comment-row m-t-0">
							<div class="p-2"><img :src="getImgUrl(list.imgages)" alt="user" width="50" /></div>
							<div class="comment-text w-100">
								<h6 class="font-medium">
									APPID：{{list.appid}} / TypeId：{{list.type_id}}
								</h6>
								<span class="m-b-15 d-block" @click="getServerURl(list.app_connect_list,list.type_id)">{{list.describe}} </span>
							</div>
						</div>
					</div>
				</div>
			</el-card>

		</div>
		<div class="col-12 align-self-center" style="margin-bottom: 20px; margin-top: 10px;">
			<h4 class="page-title">互动中心</h4>
			<h6 class="card-subtitle"> System administrator list</h6>
		</div>

		<div class="col-md-6 col-sm-6" v-for="list in lista">
			<el-card shadow="hover" class="el_card_b">
				<div class="card  card-hover">
					<div class="card-header" style="z-index: 0" @click="getServerURl(list.app_connect_list,list.type_id)">
						<b class="m-b-0 text-gray" style="height: 30px; line-height: 30px;">
							{{list.title}}
						</b>
					</div>
					<div class="card-body">
						<div class="d-flex flex-row comment-row m-t-0">
							<div class="p-2"><img :src="getImgUrl(list.imgages)" alt="user" width="50" /></div>
							<div class="comment-text w-100">
								<h6 class="font-medium">
									APPID：{{list.appid}} / TypeId：{{list.type_id}}
								</h6>
								<span class="m-b-15 d-block" @click="getServerURl(list.app_connect_list,list.type_id)">{{list.describe}}</span>
							</div>
						</div>
					</div>
				</div>
			</el-card>
		</div>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				lists: [{}],
				lista: [{}],
			};
		},
		mounted() {
			this.$admin.getAPI('default/mutual/?', {}).then(
				res => {
					let data = res.data;
					this.lists = data.data_data;
					this.lista = data.data;
					console.log(data);
				});
		},
		methods: {
			getImgUrl(img) {
				return (`https://img.hsnms.com${img}`);
			},
			getServerURl(url, type_id) {
				var strs = url.split("/"); //字符分割
				//分割字符串
				this.$router.push({
					path: `body/${strs[3]}`,
					query: {
						type_id: type_id
					}
				});
			},
		}
	}
</script>

<style>
	.el_card_b>div {
		padding: 0px;
	}

	.row .col-md-6 {
		padding-bottom: 25px;
	}

	.w-100 {
		padding-left: 15px;
	}
</style>



// WEBPACK FOOTER //
// src/components/views/admin/index.vue